var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTalkingTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 118,
    viewBox: "0 0 170 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 18)",
    fill: "#29B2EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 10)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_805_9505)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 70,
    rx: 30,
    ry: 10,
    fill: "#29B1EA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.3337 11.6666H113.334C114.254 11.6666 115 12.4133 115 13.3333V33.9966C115 34.8216 113.907 35.1133 113.495 34.4L110 28.3333H83.3337C82.4137 28.3333 81.667 27.5866 81.667 26.6666V13.3333C81.667 12.4133 82.4137 11.6666 83.3337 11.6666Z",
    fill: "url(#paint0_linear_805_9505)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.333 50C107.936 50 111.667 46.2691 111.667 41.6667C111.667 37.0643 107.936 33.3334 103.333 33.3334C98.731 33.3334 95 37.0643 95 41.6667C95 46.2691 98.731 50 103.333 50Z",
    fill: "url(#paint1_linear_805_9505)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6663 50C71.2687 50 74.9997 46.2691 74.9997 41.6667C74.9997 37.0643 71.2687 33.3334 66.6663 33.3334C62.064 33.3334 58.333 37.0643 58.333 41.6667C58.333 46.2691 62.064 50 66.6663 50Z",
    fill: "url(#paint2_linear_805_9505)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.333 53.3334C95.97 53.3334 90 59.3034 90 66.6667V69.8717C90 70.8634 90.8033 71.6667 91.795 71.6667H114.872C115.863 71.6667 116.667 70.8634 116.667 69.8717V66.6667C116.667 59.3034 110.697 53.3334 103.333 53.3334Z",
    fill: "url(#paint3_linear_805_9505)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6663 53.3334C59.303 53.3334 53.333 59.3034 53.333 66.6667V69.8717C53.333 70.8634 54.1363 71.6667 55.128 71.6667H78.2047C79.1963 71.6667 79.9997 70.8634 79.9997 69.8717V66.6667C79.9997 59.3034 74.0297 53.3334 66.6663 53.3334Z",
    fill: "url(#paint4_linear_805_9505)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M86.667 26.6666H81.667V11.6666H90.0003V23.3333C90.0003 25.175 88.5087 26.6666 86.667 26.6666Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M86.667 25.8333H81.667V11.6666H89.167V23.3333C89.167 24.7133 88.047 25.8333 86.667 25.8333Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6667 8.33337H56.6667C55.7467 8.33337 55 9.08004 55 10V30.6634C55 31.4884 56.0933 31.78 56.505 31.0667L60 25H86.6667C87.5867 25 88.3333 24.2534 88.3333 23.3334V10C88.3333 9.08004 87.5867 8.33337 86.6667 8.33337Z",
    fill: "url(#paint5_linear_805_9505)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_805_9505",
    x: 31,
    y: 36,
    width: 108,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_805_9505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_805_9505",
    x1: 93.3437,
    y1: 13.0383,
    x2: 110.11,
    y2: 36.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#037478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006063"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_805_9505",
    x1: 97.7117,
    y1: 36.045,
    x2: 110.113,
    y2: 48.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EA2E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_805_9505",
    x1: 61.0447,
    y1: 36.045,
    x2: 73.4447,
    y2: 48.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EA2E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_805_9505",
    x1: 95.93,
    y1: 52.43,
    x2: 106.277,
    y2: 72.6184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EA2E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_805_9505",
    x1: 59.443,
    y1: 53.1884,
    x2: 70.798,
    y2: 74.6384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EA2E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_805_9505",
    x1: 66.2617,
    y1: 10.2284,
    x2: 78.6817,
    y2: 33.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16979D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkingTile);
export default __webpack_public_path__ + "static/media/talkingTile.84f25b9277ed2426137f85dc99b96aa9.svg";
export { ForwardRef as ReactComponent };